const OMIT_FIELD =
  /^(?:password(?:[_-]?hash)?|secret|client[_-]?secret|private[_-]?key|api[_-]?key|token|access[_-]?token|refresh[_-]?token|session[_-]?token|reset[_-]?token|activation[_-]?token|otp[_-]?secret|signature(?:[_-]?(?:image|image[_-]?base64|access[_-]?token))?)$|.+[_-](?:password(?:[_-]?hash)?|secret|private[_-]?key|api[_-]?key|token|access[_-]?token|refresh[_-]?token|session[_-]?token|reset[_-]?token|activation[_-]?token|otp[_-]?secret)$/i;
const MASK_FIELD =
  /^(?:tax[_-]?id|social[_-]?security|ssn|pin|phone[_-]?pin|fidelity[_-]?service[_-]?team[_-]?phone[_-]?pin|routing[_-]?number|account[_-]?number|payment[_-]?(?:account|routing)[_-]?number|username|(?:schwab|td)[_-]?username|fidelity[_-]?(?:id|pin|g[_-]?number(?:[_-]?(?:primary|secondary|sam))?)|schwab[_-]?(?:master|managed[_-]?account[_-]?master)|support[_-]?email[_-]?password|fidelity[_-]?password|schwab[_-]?password|td[_-]?password)$/i;

function maskPresentValue(key: string, value: unknown) {
  if (value === null || value === undefined || value === "") return value;
  if (/^(?:social[_-]?security|ssn)$/i.test(key)) return "*********";
  if (/^payment[_-]?account[_-]?number$/i.test(key)) return "**********";
  return "********";
}

function sanitizeValue(value: unknown, seen: WeakSet<object>): unknown {
  if (value === null || value === undefined || typeof value !== "object") return value;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.toISOString();
  if (seen.has(value)) return "[Circular]";
  seen.add(value);

  if (Array.isArray(value)) {
    const result = value.map((item) => sanitizeValue(item, seen));
    seen.delete(value);
    return result;
  }

  const result: Record<string, unknown> = {};
  for (const [key, child] of Object.entries(value)) {
    if (OMIT_FIELD.test(key)) continue;
    result[key] = MASK_FIELD.test(key) ? maskPresentValue(key, child) : sanitizeValue(child, seen);
  }
  seen.delete(value);
  return result;
}

export function sanitizeStoredAuthUser<T>(user: T): T {
  return sanitizeValue(user, new WeakSet()) as T;
}
